import {notification} from "antd";

export function renderDate(time, format = 'daytime') {
	time = time ? new Date(time * 1000) : null;

	if (!time instanceof Date) return '';

	const day = ("0" + time.getDate()).slice(-2);
	const month = ("0" + (time.getMonth() + 1)).slice(-2);
	const year = time.getFullYear();
	const hours = ("0" + time.getHours()).slice(-2);
	const minutes = ("0" + time.getMinutes()).slice(-2);

	if (format === 'month') {
		return `${month}/${year}`;
	}

	if (format === 'fullTime') {
		return `${hours}:${minutes} ${day}/${month}/${year}`;
	}

	return `${day}/${month}/${year}`;
}

export function strToTime(time) {
	if(typeof time === 'undefined') return time;
	if (!isNaN(time)) {
		time = +time
	}

	time = Math.round(new Date(time).getTime() / 1000)

	return time;
}

export function apiError(messageDefault, error, response = null) {

	let message = null;

	if(error) {
		message = messageDefault;

		if(error.code === 'ERR_NETWORK') {
			message = 'Kết nối server thất bại vui lòng thử lại';
		}
		if(error.code === 'ERR_BAD_REQUEST') {
			message = 'Lỗi server vui lòng liên hệ kỹ thuật';
		}
		if(error.code === 'ERR_TIMED_OUT') {
			message = 'Server phản hồi quá lâu vui lòng thử lại';
		}
		if(error?.response) {
			if(error.response?.message) message = error.response.message
			if(error.response?.data?.message) message = error.response.data.message
		}
	}
	else if(response === 'undefined' || response === null) {
		message = messageDefault;
	}
	else if(response?.status && response.code !== "200") {
		message = (response?.message) ? response.message : messageDefault;
	}
	else if(!response?.data) {
		message = (response?.message) ? response.message : messageDefault;
	}

	if(message) notification.error({message: 'Lỗi', description: message});

	return message;
}

export function numberFormat (number, decimals)
{
	const value = parseFloat(number);

	if (isNaN(value)) return '0';

	return new Intl.NumberFormat('en-US', {
		minimumFractionDigits: 0,
		maximumFractionDigits: decimals
	}).format(value);
}

export function formatCurrency(number, currency = 'đ')
{
	const value = parseFloat(number);

	if (isNaN(value)) return '0 ' + currency;

	const formatted = new Intl.NumberFormat('en-US', {
		minimumFractionDigits: 0,
		maximumFractionDigits: 0
	}).format(value);

	return formatted + ' ' + currency;
}

export function numberToWords(number) {
	const units = ['', 'một', 'hai', 'ba', 'bốn', 'năm', 'sáu', 'bảy', 'tám', 'chín'];
	const teens = ['mười', 'mười một', 'mười hai', 'mười ba', 'mười bốn', 'mười năm', 'mười sáu', 'mười bảy', 'mười tám', 'mười chín'];
	const tens = ['', '', 'hai mươi', 'ba mươi', 'bốn mươi', 'năm mươi', 'sáu mươi', 'bảy mươi', 'tám mươi', 'chín mươi'];
	const thousands = ['', 'nghìn', 'triệu', 'tỷ', 'nghìn tỷ', 'triệu tỷ', 'tỷ tỷ'];

	if (number === 0) {
		return 'không';
	}

	let words = '';
	let power = 0;

	while (number > 0) {
		const chunk = number % 1000;

		if (chunk > 0) {
			let chunkWords = '';
			if (chunk < 10) {
				chunkWords = units[chunk];
			} else if (chunk < 20) {
				chunkWords = teens[chunk - 10];
			} else if (chunk < 100) {
				chunkWords = tens[Math.floor(chunk / 10)];
				if (chunk % 10 !== 0) {
					chunkWords += ' ' + units[chunk % 10];
				}
			} else {
				chunkWords = units[Math.floor(chunk / 100)] + ' trăm';
				if (chunk % 100 !== 0) {
					chunkWords += ' ' + tens[Math.floor((chunk % 100) / 10)];
					if (chunk % 10 !== 0) {
						chunkWords += ' ' + units[chunk % 10];
					}
				}
			}

			words = chunkWords + ' ' + thousands[power] + ' ' + words;
		}

		number = Math.floor(number / 1000);
		power++;
	}

	return words.trim();
}

export const handleRequest = promise => {
	return promise.then(data => ([undefined, data, null])).catch(error => ([error, undefined, null]));
}

export function isEmpty(variable) {
	// Kiểm tra nếu biến là undefined hoặc null
	if (variable === undefined || variable === null) {
		return true;
	}

	// Kiểm tra nếu biến là một chuỗi và có độ dài bằng 0
	if (typeof variable === 'string' && variable.length === 0) {
		return true;
	}

	// Kiểm tra nếu biến là một mảng và có độ dài bằng 0
	if (Array.isArray(variable) && variable.length === 0) {
		return true;
	}

	// Kiểm tra nếu biến là một đối tượng và không có thuộc tính nào
	if (typeof variable === 'object' && Object.keys(variable).length === 0) {
		return true;
	}

	// Trường hợp còn lại, biến không rỗng
	return false;
}

export function renderAddress(cityKey, districtKey, wardKey, country) {

	let province = '';
	let district = '';
	let ward = '';
	if(cityKey === '') return '';
	if(country.city[cityKey] !== undefined) {
		province = country.city[cityKey];
	}
	if(province === '' || districtKey === '') return province;

	if(country.district[cityKey] !== undefined && country.district[cityKey][districtKey] !== undefined) {
		district = country.district[cityKey][districtKey];
	}
	if(district === '') return province;
	if(wardKey === '') return district+', '+province;
	if(country.ward[districtKey] !== undefined && country.ward[districtKey][wardKey] !== undefined) {
		ward = country.ward[districtKey][wardKey];
	}
	if(ward === '') return district+', '+province;
	return ward+', '+district+', '+province;
}

export function isNumeric(str) {
	if (typeof str != "string") return false // we only process strings!
	return !isNaN(str) && !isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
}